import pricingPolicyRepository from "@/repositories/pricing-policy.repository";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";


export function useGetPricingPolicy(args: { id: string }) {
    return useQuery({
        queryKey: ['pricing-policies', 'get', args.id],
        queryFn: () => pricingPolicyRepository.get(args),
    });
}

export function useListPricingPolicies() {
    return useQuery({
        queryKey: ['pricing-policies', 'list'],
        queryFn: () => pricingPolicyRepository.list(),
    });
}

export function useCreateOrEditPricingPolicyMutation() {
    const client = useQueryClient();
    return useMutation({
        mutationFn: pricingPolicyRepository.create,
        onSuccess() {
            client.invalidateQueries({
                queryKey: ['pricing-policies']
            })
        }
    });
}

export function useRemovePricingPolicyMutation() {
    const client = useQueryClient();
    return useMutation({
        mutationFn: pricingPolicyRepository.remove,
        onSuccess() {
            client.invalidateQueries({
                queryKey: ['pricing-policies']
            })
        }
    });
}